import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['associatedUnits', 'yesRadio', 'noRadio'];

  connect() {
    this.sync();
  }

  // Keep DOM and MDC in sync on page load
  sync() {
    const selected = this.element.querySelector(
      'input[name*="[associated_with_all_units]"]:checked'
    );
    const val = (selected?.value ?? '').toLowerCase();
    const isNo = val === '0' || val === 'false';

    if (isNo) {
      this.showUnits();
    } else {
      this.hideUnits();
    }
  }

  // Handlers from radio data-actions
  showUnits() {
    this.associatedUnitsTarget.classList.remove('hidden');
  }

  hideUnits() {
    this.associatedUnitsTarget.classList.add('hidden');
  }
}
